import { render, staticRenderFns } from "./BankInformation.vue?vue&type=template&id=01935672&scoped=true"
import script from "./BankInformation.vue?vue&type=script&lang=js"
export * from "./BankInformation.vue?vue&type=script&lang=js"
import style0 from "./BankInformation.vue?vue&type=style&index=0&id=01935672&prod&scoped=true&lang=css"
import style1 from "./BankInformation.vue?vue&type=style&index=1&id=01935672&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01935672",
  null
  
)

export default component.exports